export enum ByteOrder32Bits {
  B3_B2_B1_B0 = 0,
  B1_B0_B3_B2 = 1,
  B2_B3_B0_B1 = 2,
  B0_B1_B2_B3 = 3,
}

export enum ByteOrder16Bits {
  B1_B0 = 0,
  B0_B1 = 1,
}

export interface DeviceConfigParser {}
